import { useTranslation } from 'react-i18next';
import { useAdminEmailFlowRunSendsQuery } from '@/generated/graphql';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

type Props = { runId: string | null; onOpenChange: (v: boolean) => void };

const RunDetailsDialog = ({ runId, onOpenChange }: Props) => {
  const { t } = useTranslation();
  const { data } = useAdminEmailFlowRunSendsQuery({ variables: { runId: runId! }, skip: !runId });
  const rows = data?.adminEmailFlowRunSends ?? [];
  return (
    <Dialog open={!!runId} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader><DialogTitle>{t('admin.emailFlows.runs.title')}</DialogTitle></DialogHeader>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Step</TableHead>
              <TableHead>Sent at</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Subject</TableHead>
              <TableHead>Lang</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{r.step_order ?? '—'}</TableCell>
                <TableCell className="text-sm">{new Date(r.sent_at).toLocaleString()}</TableCell>
                <TableCell>
                  {r.success
                    ? <Badge>OK</Badge>
                    : <Badge variant="destructive" title={r.error || ''}>FAIL</Badge>}
                </TableCell>
                <TableCell className="text-sm">{r.subject_used}</TableCell>
                <TableCell>{r.language_used}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground">—</TableCell></TableRow>}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default RunDetailsDialog;
